import React from 'react'
import { connect } from "react-redux";
import { SetDepositPayments_PHC } from '$Deposits/store/actions/DepositPost'
import { PHC_Submit } from '$Deposits/store/actions/DepositEvent'
import { GetParamsData } from '$Deposits/lib/LibCommonData'


class PHC extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {
        const { LivechatClick } = GetParamsData()
        const {
            SetDepositPayments_PHC,
            DepositNextStep,
            DepositSuccessPage,
            AvailableMethods,
            MoneyInput,
            SubmitBtn,
            NextStep,
            SuccessPage,
            BankSelect,
            BanksBankAccounts=[],
            BankNone
        } = this.props
        return (
            <>
                            {
                    //没有银行卡
                    BanksBankAccounts.length == 0 &&
                    <>
                        <BankNone LivechatClick={LivechatClick} methods={'PHC'} />
                    </>
                }
                {
                    !DepositNextStep && !DepositSuccessPage && BanksBankAccounts.length > 0 &&
                    <>
                        <AvailableMethods />
                        <BankSelect />
                        <MoneyInput />
                        <SubmitBtn
                            submitBtn={PHC_Submit}
                            onPress={() => { SetDepositPayments_PHC() }}
                            submitBtnItem={'Chuyển'}
                        />
                        <div className='noteDep'>
                            <div className='notDepTitle'>Lưu ý quan trọng: </div>
                            <div className='notDepContent'>
                                <p>1. Chọn đúng loại thẻ và mệnh giá thẻ cào cần nạp.</p>
                                <p>2. Số tiền nạp thực tế vào tài khoản của bạn sẽ bằng mệnh giá thẻ cào trừ đi phí nạp tiền.</p>
                                <p>3. Chọn đúng loại thẻ và mệnh giá thẻ cào cần nạp.</p>
                            </div>
                        </div>
                    </>
                }
                {
                    DepositNextStep &&
                    <NextStep />
                }
                {
                    DepositSuccessPage &&
                    <SuccessPage />
                }
            </>
        );
    }
}

const mapStateToProps = state => ({
    DepositNextStep: state.DepositNextStep,
    DepositSuccessPage: state.DepositSuccessPage,
    BanksBankAccounts: state.BanksBankAccounts,
});
const mapDispatchToProps = {
    SetDepositPayments_PHC: (data = {}) => SetDepositPayments_PHC(data),
};
export default connect(mapStateToProps, mapDispatchToProps)(PHC);


